import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';

// Styled button to reflect progress and disabled state
const ProgressButton = styled(Box)(({ theme, progress, disabled, colored, textColor, isButton }) => ({
    position: 'relative',
    borderRadius: '50px',
    padding: '4px 10px',
    backgroundColor:
        colored ??
        // eslint-disable-next-line no-nested-ternary
        (disabled ? '#e0e0e0' : progress === 100 ? '#DBFFF2' : progress < 45 ? '#FFDEDE' : progress < 80 ? '#F3C62340' : '#DBFFF2'),
    // eslint-disable-next-line no-nested-ternary
    color: disabled ? '#9e9e9e' : progress === 100 ? '#46CB9C' : progress < 45 ? `#AF6666` : progress < 80 ? `#9D8E63` : '#46CB9C',
    border: isButton
        ? `1px solid ${
              textColor ??
              // eslint-disable-next-line no-nested-ternary
              (disabled ? '#bdbdbd' : progress === 100 ? '#46CB9C' : progress < 45 ? '#CE2828' : progress < 80 ? '#DFB622' : '#46CB9C')
          }`
        : 'none',
    // '&:hover': {
    //     // eslint-disable-next-line no-nested-ternary
    //     backgroundColor: colored ?? (disabled ? '#e0e0e0' : progress === 100 ? '#DBFFF2' : `rgba(255, 255, 255, 1)`)
    // },
    cursor: disabled ? 'not-allowed' : 'pointer',
    minWidth: '100px'
}));

const PublishButton = ({ progress, onClick, disabled, text, bgColor, textColor, isButton }) => (
    <Box display="flex" flexDirection="column" alignItems="center">
        <ProgressButton
            progress={progress}
            variant="contained"
            disabled={disabled}
            colored={bgColor}
            textColor={textColor}
            isButton={isButton}
            onClick={onClick}
            sx={{
                overflow: 'hidden'
            }}
        >
            {/* {progress < 100 && !disabled && (
                <Box
                    position="absolute"
                    left={0}
                    top={0}
                    height="100%"
                    width={`${progress}%`}
                    // eslint-disable-next-line no-nested-ternary
                    backgroundColor={progress === 100 ? '#d4f7dc' : progress < 45 ? '#FFDEDE' : progress < 80 ? '#F3C62340' : '#DBFFF2'}
                    style={{
                        borderRadius: '50px 0 0 50px'
                    }}
                    zIndex={20}
                />
            )} */}
            <Typography
                variant="h6"
                sx={{ position: 'relative', zIndex: 50, textAlign: 'center' }}
                style={
                    // eslint-disable-next-line no-nested-ternary
                    { color: textColor ?? (disabled ? '#9e9e9e' : progress > 80 ? '#4caf50' : 'inherit') }
                }
            >
                {progress === 100 ? text : `${progress}%`}
            </Typography>
        </ProgressButton>
    </Box>
);

export default PublishButton;
